var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-row"},[_c('ul',{staticClass:"item-row"},[_c('ItemHeadBox',{attrs:{"title":_vm.tile.name}}),_vm._v(" "),_vm._l((_vm.tile.services),function(service){return _c('div',{key:service.id},[_c('ItemBox',{attrs:{"service":service}})],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84a5df34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemRow.vue
// module id = null
// module chunks = 